import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../Wrapper';
import { getClassModifiers } from '../../utils';
import { useGetImages } from '../../hooks';
import { getStylesToUpdate, checkIfRowHasColumns } from './helpers';
import { renderChildren, hasChildren } from '../../helpers';
import { COLUMN } from '../../constants';

const Layout = React.forwardRef(
  (
    {
      type,
      children,
      settings,
      modifier,
      backgroundImage,
      tagType,
      dataNoSnippet,
      sticky,
      VariantComponent,
      ...otherProps
    },
    ref
  ) => {
    const {
      data: { getFile: { url = null } = {} }
    } = useGetImages(backgroundImage);
    const style = getStylesToUpdate({ backgroundImage: url });
    const { title } = settings;
    const classModifiers = getClassModifiers(type, { modifier, sticky, ...otherProps });
    const additionalRowModifier = checkIfRowHasColumns(type, children) ? ' display-row' : '';

    if (type === COLUMN && !hasChildren(children)) return null;

    const otherWrapperProps = {};
    if (dataNoSnippet) otherWrapperProps['data-nosnippet'] = true;

    const WrapperComponent = VariantComponent || Wrapper;

    return (
      <WrapperComponent
        ref={ref}
        tagType={tagType}
        className={type}
        modifiers={`${classModifiers}${additionalRowModifier}`}
        style={style}
        {...otherWrapperProps}>
        {title && <h2 className="heading heading--section">{title}</h2>}
        {renderChildren(children, otherProps)}
      </WrapperComponent>
    );
  }
);

Layout.propTypes = {
  type: PropTypes.string.isRequired,
  sticky: PropTypes.bool,
  settings: PropTypes.shape({
    title: PropTypes.string
  }),
  modifier: PropTypes.string,
  backgroundImage: PropTypes.string,
  tagType: PropTypes.string,
  dataNoSnippet: PropTypes.bool,
  VariantComponent: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

Layout.defaultProps = {
  settings: {
    title: ''
  },
  backgroundImage: '',
  modifier: '',
  tagType: '',
  dataNoSnippet: false,
  sticky: false,
  VariantComponent: null
};

export default Layout;
